import React from 'react';
import { fmtDate } from '../lib/utils';
import PrintHeader, { TitlePill, DEFAULT_COMPANY } from './PrintHeader';

const BLUE = '#1E3A8A';

function DottedLine({ en, ar, value }) {
  return (
    <div className="flex items-end gap-3 text-base" style={{ color: BLUE }}>
      <span className="text-[15px] font-semibold whitespace-nowrap">{en}</span>
      <span className="flex-1 border-b border-dotted border-slate-400 text-slate-900 font-semibold px-3 min-h-[30px] text-[18px]">{value}</span>
      <span className="font-arabic text-[18px] whitespace-nowrap" dir="rtl" style={{ unicodeBidi: 'isolate' }}>{ar}</span>
    </div>
  );
}

export default function ReceiptPrint({ invoice, payment, company }) {
  const c = { ...DEFAULT_COMPANY, ...(company || {}) };
  const amount = payment ? payment.amount : invoice.amountPaid;
  const kd = Math.floor(amount);
  const fils = Math.round((amount - kd) * 1000);
  const method = payment?.method || 'Cash';
  const reference = payment?.reference || '';
  return (
    <div className="font-sans text-base p-5 rounded" style={{ minWidth: 640, backgroundColor: '#FDF4F6' }}>
      <PrintHeader company={c} />
      <TitlePill en="Receipt Voucher" ar="سند قبض" number={`RV-${invoice.invoiceNumber}`} date={fmtDate(payment?.date || invoice.date)} />

      <div className="flex gap-10 items-stretch">
        <div className="flex-1 space-y-7 pt-2">
          <DottedLine en="Received From Mr./Mrs" ar="وصلنا من السيد / السادة" value={invoice.customerName || 'Walk-in Customer'} />
          <DottedLine en="The Sum of K.D." ar="مبلغ وقدره" value={`${kd} KD and ${fils} Fils`} />
          <DottedLine en="Cash/Cheque No." ar="نقداً / شيك رقم" value={method === 'Cash' ? 'Cash / نقداً' : reference || method} />
          <DottedLine en="Bank" ar="على بنك" value={method === 'Cash' ? '—' : method} />
          <DottedLine en="Being of" ar="وذلك عن" value={`Payment against Invoice ${invoice.invoiceNumber}`} />
        </div>
        <div className="flex flex-col items-center justify-between w-60 shrink-0 pt-2">
          <table className="border-2 text-center w-full" style={{ borderColor: BLUE, color: BLUE }}>
            <thead>
              <tr>
                <th className="px-4 py-1.5 text-sm border-r-2" style={{ borderColor: BLUE }}>K.D. · <span className="font-arabic text-base">دينار</span></th>
                <th className="px-4 py-1.5 text-sm">Fils · <span className="font-arabic text-base">فلس</span></th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-t-2" style={{ borderColor: BLUE }}>
                <td className="px-4 py-2 num font-bold text-xl text-slate-900 border-r-2" style={{ borderColor: BLUE }} data-testid="receipt-kd">{kd}</td>
                <td className="px-4 py-2 num font-bold text-xl text-slate-900" data-testid="receipt-fils">{String(fils).padStart(3, '0')}</td>
              </tr>
            </tbody>
          </table>
          <div className="text-center text-sm mt-12" style={{ color: BLUE }}>
            <div className="border-t border-dotted border-slate-400 w-56 mb-1.5" />
            <p>Receiver's Signature · <span className="font-arabic text-base">توقيع المستلم</span></p>
          </div>
        </div>
      </div>
    </div>
  );
}
